// extracted by mini-css-extract-plugin
module.exports = {"Acknowledgments":"Acknowledgments_Acknowledgments__1IEvG"};